import { render, staticRenderFns } from "./NotImplementedObjectDrawer.vue?vue&type=template&id=5d1c9efd&"
import script from "./NotImplementedObjectDrawer.vue?vue&type=script&lang=ts&"
export * from "./NotImplementedObjectDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports